import React from 'react'
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '../contexts/AuthContext'
import Router from './core/Router';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers';

function App() {

  return (
        <AuthProvider>
           <LocalizationProvider dateAdapter={AdapterMoment}>
            <BrowserRouter>  
              <Router />
            </BrowserRouter>  
          </LocalizationProvider>
        </AuthProvider> 
        
  );
}

export default App;
